<template>
  <div class="contactUsModel">
    <div class="obody">
      <h1>{{ labels.h1 }}</h1>
      <h2>{{ labels.h2 }}</h2>
      <button @click="$fun.clickJs()">
        {{ labels.btn }}
      </button>
    </div>
  </div>
</template>
<script>
import pageData from "../unitl/pageData";
import { getFaqLabel } from "../unitl/faqLocale";

export default {
  computed: {
    homePage() {
      return pageData.find((item) => item.router === "centro-de-ayuda") || {};
    },
    labels() {
      const fanyi = this.$store.state.fanyi;
      return {
        h1: getFaqLabel(this.homePage.contactLabels, "h1", fanyi),
        h2: getFaqLabel(this.homePage.contactLabels, "h2", fanyi),
        btn: getFaqLabel(this.homePage.contactLabels, "btn", fanyi),
      };
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
.contactUsModel {
  background-color: #f6f6f8;
  height: 338.69px;
  display: flex;
  justify-content: center;
  align-items: center;
  .obody {
    width: 1060px;
    * {
      text-align: center;
    }

    h1 {
      color: #3c4043;
      font-size: 21px;
      font-weight: 500;
      line-height: 1.5em;
      height: 30px;
      margin-bottom: 5px;
    }
    h2 {
      font-size: 16px;
      line-height: 28px;
      margin-bottom: 34px;
    }
    button {
      width: 492px;
      height: 60px;
      border: 1px solid #bddbb8;
      color: #009246;
      font-size: 15px;
      font-weight: 600;
      border-radius: 12px;
      transition: background-color 0.3s, border-color 0.3s, color 0.3s;
      display: block;
      margin: 0 auto;
      cursor: pointer;
      &:hover {
        color: #009246;
        background-color: #f1faef;
        border-color: #bddbb8;
      }
    }
  }
}
</style>
